import React, { useState, useMemo } from 'react';
import { Segment, Tabs, TabPanel } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import { ClassSpecial } from '@op/constants/common';
import { IDiscussionItem } from '../types';
import OverviewLanguages from '../OverviewLanguages';
import './index.scss';
import { getTextByGlobal } from '@op/utils/languageValue';
import { DBO_POINT } from '@op/operationLog/buriedPoint';
import CardCommon from '@op/components/CardCommon';

interface EventOverviewProps {
  item: IDiscussionItem;
  filterParams: Record<string, any> | undefined;
}

type TOverviewTab = 'Summary' | 'Language';

/** Overview 区域：Summary | Language 双 Tab */
export default function EventOverview({
  item,
  filterParams,
}: EventOverviewProps) {
  const { formatMessage, isEn } = useLanguage();
  const [overviewTab, setOverviewTab] = useState<TOverviewTab>('Summary');

  const summaryText = useMemo(() => {
    return getTextByGlobal({ "origin": "event_gpt_content", "en": "event_gpt_content_en", "zh": "event_gpt_content_cn" }, isEn, item);
  }, [item, isEn]);

  return (
    <div className="dbo-event-overview">
      <Segment
        value={overviewTab}
        onChange={(value) => {
          setOverviewTab(value as TOverviewTab);
          DBO_POINT.btn("HC_summaryChange", value);
        }}
        options={[
          { text: formatMessage({ id: 'Summary' }), value: 'Summary' },
          { text: formatMessage({ id: 'Language & Channel' }), value: 'Language' },
        ]}
      />

      <Tabs
        className={ClassSpecial.TAB_NONE}
        activeId={overviewTab}
        destroyInactiveTabPanel={false}
      >
        <TabPanel id="Summary">
          <CardCommon contentCard hasEmptyImg={false} empty={!summaryText} emptyHeight={100} className="dbo-event-overview-summary-content">
            {summaryText && (
              <div className="dbo-event-overview-summary-text">
                {summaryText}
              </div>
            )}
          </CardCommon>
        </TabPanel>

        <TabPanel id="Language">
          <OverviewLanguages item={item} filterParams={filterParams} />
        </TabPanel>
      </Tabs>
    </div>
  );
}
